import { getMessages } from '../../../../../../store/constants';

export const MY_WORK_FILTER_BAR_ADD_FILTER = getMessages().getText('assigned_to_me.filter_bar.actions.add');
export const MY_WORK_FILTER_BAR_UNSELECT_ALL_FILTERS = getMessages().getText('assigned_to_me.filter_bar.actions.unselect.all');
export const MY_WORK_FILTER_BAR_SELECT_ALL_FILTERS = getMessages().getText('assigned_to_me.filter_bar.actions.select.all');
